import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Copy, Share2, Gift } from "lucide-react";
import { toast } from "sonner";

export default function Referral() {
    const [data, setData] = useState(null);

    useEffect(() => {
        api.get("/sponsorships/referral").then((r) => setData(r.data));
    }, []);

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(data.referral_code);
            toast.success("Code copié");
        } catch {
            toast.error("Impossible de copier");
        }
    };

    const shareLink = data
        ? `${window.location.origin}/register?ref=${encodeURIComponent(data.referral_code)}`
        : "";

    const copyLink = async () => {
        try {
            await navigator.clipboard.writeText(shareLink);
            toast.success("Lien copié");
        } catch {
            toast.error("Impossible de copier");
        }
    };

    if (!data) return <div className="p-12 text-zinc-500">Chargement…</div>;

    return (
        <div className="max-w-3xl mx-auto px-6 py-16 space-y-8">
            <header>
                <div className="text-[11px] uppercase tracking-[0.25em] text-orange-500 font-bold mb-2">
                    Programme parrainage
                </div>
                <h1 className="font-display text-5xl md:text-7xl uppercase tracking-tight leading-none">
                    Invitez un autre sponsor
                </h1>
                <p className="text-zinc-400 mt-3">
                    Recevez <span className="font-bold text-orange-500">+{data.bonus_per_referral} points</span> chacun
                    quand un nouveau sponsor s'inscrit avec votre code.
                </p>
            </header>

            <div className="card-tu space-y-6">
                <div>
                    <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-bold mb-2">
                        Votre code parrainage
                    </div>
                    <div className="flex items-center gap-2">
                        <div
                            data-testid="referral-code"
                            className="font-display text-3xl text-orange-500 bg-zinc-950 border border-zinc-800 px-4 py-3 flex-1 tracking-widest"
                        >
                            {data.referral_code}
                        </div>
                        <button
                            onClick={copy}
                            data-testid="copy-code"
                            className="btn-primary py-3 px-4 text-xs"
                        >
                            <Copy size={14} /> Copier
                        </button>
                    </div>
                </div>

                <div>
                    <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-bold mb-2">
                        Lien d'invitation
                    </div>
                    <div className="flex items-center gap-2">
                        <input
                            readOnly
                            value={shareLink}
                            className="input-tu flex-1 font-mono text-xs"
                            data-testid="referral-link"
                        />
                        <button
                            onClick={copyLink}
                            data-testid="copy-link"
                            className="btn-ghost py-3 px-4 text-xs"
                        >
                            <Share2 size={14} /> Copier
                        </button>
                    </div>
                </div>

                <div className="grid grid-cols-2 gap-px bg-zinc-800 border border-zinc-800">
                    <div className="bg-[#09090b] p-5 text-center">
                        <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-bold mb-1">
                            Sponsors parrainés
                        </div>
                        <div className="font-display text-4xl text-orange-500">{data.referred_count}</div>
                    </div>
                    <div className="bg-[#09090b] p-5 text-center">
                        <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-bold mb-1">
                            Points gagnés
                        </div>
                        <div className="font-display text-4xl text-orange-500">
                            {data.referred_count * data.bonus_per_referral}
                        </div>
                    </div>
                </div>
            </div>

            <div className="card-tu border-l-4 border-l-orange-500 flex items-start gap-3">
                <Gift className="text-orange-500 shrink-0" />
                <p className="text-zinc-300 text-sm">
                    Votre filleul reçoit également <span className="font-bold text-orange-500">+{data.bonus_per_referral} points</span> à
                    son inscription. Plus vous parrainez, plus vite vous montez en niveau Sponsormania.fr.
                </p>
            </div>
        </div>
    );
}
